import { Text } from '@chakra-ui/react'
import React from 'react'


const Footer = () => {
  return (
    <Text align={"right"} fontSize={["10px"]} >
      Designed and Developed By Tarun Sharma
    </Text>
  )
}

export default Footer
